import { ReactElement, useMemo } from 'react';

import { useUIV2State } from '~hooks/useUIV2State';

import { DashboardVariantV1, DashboardVariantV2 } from './Variant';

const Dashboard = (): ReactElement => {
  const { isEnabledUIV2 } = useUIV2State();

  const VariantComponent = useMemo(
    () => (!isEnabledUIV2 ? DashboardVariantV1 : DashboardVariantV2),
    [isEnabledUIV2],
  );

  return <VariantComponent />;
};

export default Dashboard;
